import { useTranslation } from 'react-i18next'
import { useAuth } from '@wehunt/core-web'
import { AccountCheckNotice } from '@wehunt/ui'

/**
 * Renders the "Checking for an existing account…" overlay while AuthProvider
 * is running the Apple cross-team repair probe.
 *
 * Mounted at the app root, alongside the router rather than inside it: the
 * plan that triggers this arrives while the user is already `signed-in`, and
 * SignInPage navigates away to `/` on that status -- so by the time the
 * notice needs to show, the sign-in page is long gone. It has to render
 * regardless of the current route, which only a composition-root mount can
 * guarantee.
 */
export function AppleRepairNotice() {
  const { checkingExistingAccount } = useAuth()
  const { t } = useTranslation('app')

  if (!checkingExistingAccount) return null

  return <AccountCheckNotice message={t('signIn.checkingExistingAccount')} />
}
